export const firebaseConfig = {
  apiKey: "AIzaSyBqvCfrPgXwc6yNsOclbq6QssB1ZaCH-Uc",
  authDomain: "kasoot-52e46.firebaseapp.com",
  databaseURL: "https://kasoot-52e46.firebaseio.com",
  projectId: "kasoot-52e46",
  storageBucket: "kasoot-52e46.appspot.com",
  messagingSenderId: "48814919623"
};


// WEBPACK FOOTER //
// ./src/environment.ts